import { doc, updateDoc } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Scenario from '../../models/Scenario';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';

async function updateScenario(
  scenario: Scenario,
  auth: Authentication
): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new UpdateScenarioFailure('Unauthorized', 'unauthorized');
  }

  try {
    const scenarioDocPatch = scenario.toFirestorePatch();
    const db = firestore;

    await updateDoc(
      doc(db, FirestoreCollections.scenarios, scenario.id),
      scenarioDocPatch
    );

    return;
  } catch (e) {
    console.log('error: ', e);
    throw new UpdateScenarioFailure();
  }
}

export class UpdateScenarioFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default updateScenario;
